export default __webpack_public_path__ + "img/icon-down.asset.504b229f.png";